<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.limiteMensagem"
        ref="RkmDataTable"
    >
        <template v-slot:cell(limite_mensal)="{item}">
            {{ formatNumber(item.limite_mensal) }}
        </template>

        <template v-slot:cell(mensagens_consumidas)="{item}">
            {{ formatNumber(item.mensagens_consumidas) }}
        </template>

        <template v-slot:cell(mensagens_disponiveis)="{item}">
            {{ formatNumber(item.mensagens_disponiveis) }}
        </template>

        <template v-slot:cell(limite_ativo)="{item}">
            <span :class="isActive(item.limite_ativo) ? 'text-success' : 'text-danger'">
                {{ isActive(item.limite_ativo) ? 'Ativo' : 'Inativo' }}
            </span>
        </template>

        <template v-slot:cell(actions)="{item}">
            <rkm-button
                v-if="authorize('cadastro-limite-mensagem-update')"
                :to="{name: 'cadastro-limite-mensagem-edit', params: {id: item.cliente_limite_mensagem_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-limite-mensagem-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'cliente_nome', label: 'Cliente', name: 'cadastro_cliente.nome', searchable: true, sortable: true},
                {class: 'text-right', key: 'limite_mensal', label: 'Limite mensal', name: 'limite.limite_mensal', sortable: true},
                {class: 'text-right', key: 'mensagens_consumidas', label: 'Consumidas no mês', name: 'consumo.mensagens_consumidas', sortable: true},
                {class: 'text-right', key: 'mensagens_disponiveis', label: 'Disponíveis', name: 'mensagens_disponiveis', sortable: true},
                {class: 'text-center', key: 'limite_ativo', label: 'Status', name: 'limite.ativo', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        formatNumber(value) {
            return new Intl.NumberFormat('pt-BR').format(Number(value || 0))
        },
        isActive(value) {
            return Number(value) === 1
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.limiteMensagem
                .destroy(item.cliente_limite_mensagem_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation(
                'Confirmação',
                `Deseja realmente excluir o limite de mensagens do cliente ${item.cliente_nome}?`,
                destroy,
                this.handleError
            )
        },
    },
    mixins: [authorization, error, notification],
}
</script>
